import { useState } from "react";

/**
 * 📥 useEmployeeImportFlow Hook
 * يدير states تدفق الاستيراد والمعاينة والقرارات
 */
export function useEmployeeImportFlow() {
  // ============== IMPORT FLOW STATES ==============
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [pendingImportFile, setPendingImportFile] = useState(null);

  // ============== IMPORT PREVIEW STATES ==============
  const [importPreviewOpen, setImportPreviewOpen] = useState(false);
  const [importPreviewData, setImportPreviewData] = useState({
    duplicates: [],
    failed: [],
    parseWarnings: [],
    summary: {},
  });
  const [duplicateDecisions, setDuplicateDecisions] = useState({});
  const [previewStep, setPreviewStep] = useState(1); // 1 = errors/warnings, 2 = duplicate review
  const [expandedDupKeys, setExpandedDupKeys] = useState({});

  // ============== IMPORT PROGRESS STATES ==============
  const [isPreparingImport, setIsPreparingImport] = useState(false);
  const [isImportCommitting, setIsImportCommitting] = useState(false);

  // Floating progress widget shown during the commit step (estimated
  // percent/ETA — the backend runs the import as a single request with no
  // real progress events). Closing/minimizing this never cancels the import.
  const [importProgress, setImportProgress] = useState({
    visible: false,
    minimized: false,
    percent: 0,
    etaSeconds: null,
    fileName: "",
  });

  // ============== IMPORT RESULTS STATES ==============
  const [importResultsOpen, setImportResultsOpen] = useState(false);
  const [importResultsData, setImportResultsData] = useState(null);

  // ============== HELPER FUNCTION: RESET IMPORT FLOW ==============
  const resetImportFlow = () => {
    setPendingImportFile(null);
    setImportPreviewOpen(false);
    setImportPreviewData({
      duplicates: [],
      failed: [],
      parseWarnings: [],
      summary: {},
    });
    setDuplicateDecisions({});
    setPreviewStep(1);
    setExpandedDupKeys({});
    setIsPreparingImport(false);
    setIsImportCommitting(false);
    setImportProgress({
      visible: false,
      minimized: false,
      percent: 0,
      etaSeconds: null,
      fileName: "",
    });
    setImportResultsOpen(false);
    setImportResultsData(null);
    setError("");
  };

  // ============== RETURN PUBLIC API ==============
  return {
    // Flow states
    loading,
    setLoading,
    error,
    setError,

    // File & preview states
    pendingImportFile,
    setPendingImportFile,
    importPreviewOpen,
    setImportPreviewOpen,
    importPreviewData,
    setImportPreviewData,

    // Decision states
    duplicateDecisions,
    setDuplicateDecisions,
    previewStep,
    setPreviewStep,
    expandedDupKeys,
    setExpandedDupKeys,

    // Progress states
    isPreparingImport,
    setIsPreparingImport,
    isImportCommitting,
    setIsImportCommitting,
    importProgress,
    setImportProgress,

    // Results states
    importResultsOpen,
    setImportResultsOpen,
    importResultsData,
    setImportResultsData,

    // Helper methods
    resetImportFlow,
  };
}
